// extracted by mini-css-extract-plugin
export var activeButton = "MobileImageSlider-module--activeButton--d898f";
export var cMarginTop = "MobileImageSlider-module--c-margin-top--a3180";
export var cPadding = "MobileImageSlider-module--c-padding--4184b";
export var cPaddingBottom = "MobileImageSlider-module--c-padding-bottom--56c14";
export var cPaddingTop = "MobileImageSlider-module--c-padding-top--841ca";
export var content = "MobileImageSlider-module--content--cf10a";
export var imageWrapper = "MobileImageSlider-module--imageWrapper--825b9";
export var imageWrapper2 = "MobileImageSlider-module--imageWrapper2--9d72b";
export var mainWrapper = "MobileImageSlider-module--mainWrapper--fca4e";
export var maxWidth = "MobileImageSlider-module--max-width--5715d";
export var onPrimaryOutline = "MobileImageSlider-module--onPrimaryOutline--3d0ac";
export var primaryFilled = "MobileImageSlider-module--primaryFilled--fe68f";
export var primaryFilledTwo = "MobileImageSlider-module--primaryFilledTwo--8242e";
export var primaryNoStrokeWithIcon = "MobileImageSlider-module--primaryNoStrokeWithIcon--00173";
export var primaryOutline = "MobileImageSlider-module--primaryOutline--a9687";
export var primaryOutlineWithIcon = "MobileImageSlider-module--primaryOutlineWithIcon--78ead";
export var progressBar = "MobileImageSlider-module--progressBar--ac8c7";
export var progressFill = "MobileImageSlider-module--progressFill--7d7d3";
export var sliderContainer = "MobileImageSlider-module--sliderContainer--71364";
export var textWrapper = "MobileImageSlider-module--textWrapper--ba62a";
export var title = "MobileImageSlider-module--title--b2339";